/**
 * <PageEditor 
 *		// please describe props here
 *	/>
 *
 * This is...
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import "./PageEditor.scss";
import Form from 'components/Form';
import locale from './locale';

class PageEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: {},
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillReceiveProps({ page }) {
    if (page) {
      this.setState({
        page,
      });
    }
  }

  componentWillMount() {

  }

  onSubmit() {
    this.props.onSubmit(this.state.page);
  }
  
  onChange(page) {
    this.setState({
      page,
    });
  }

  render() {
    const {
      isEdit,
      onSubmit,
      onClose,
    } = this.props;

    const {
      page,
    } = this.state;

    const editPageSchema= [
      {
        name: 'title',
        label: __('Page Title', locale),
        type: "text"
      },
      {
        name: 'page_setting.slug',
        label: __('Slug', locale),
        placeholder: '/example',
        type: "text"
      },
      {
        name: 'page_setting.meta',
        label: __('Meta Data', locale),
        type: "objectArray",
        max: 50,
        objectSchema: [
          {
            name: 'name',
            label: __('Name', locale),
            type: 'text',
          },
          {
            name: 'content',
            label: __('Content', locale),
            type: 'textarea',
          },
      
        ],
      },
    ];

    return (
      <div className={classnames('PageEditor', { isEdit })}>
        <div className='PageEditor--content' ref={(r)=>{ 
          this.scrollingContainerRef = r;
        }}>
          <h3>{page.title || __('New Page', locale)}</h3>
          <div className='PageEditor--formWrapper'>
            <Form
              onChange={this.onChange}
              schema={editPageSchema}
              formData={page}
              formStyle='outline'
              // getValidationRef={getValidationRef}
              scrollingContainerRef={this.scrollingContainerRef}
            />
            <div className='btn-wrapper'>
              <button onClick={onClose} className='btn btn-default'>{__('Cancel', locale)}</button>
              <button onClick={this.onSubmit} className='btn btn-primary'>{__('Submit', locale)}</button>
            </div>
            <div>
              <p>
                <a onClick={this.onDelete} className='btn-link PageEditor--deletePage'>{__('Delete this page', locale)}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PageEditor;



// WEBPACK FOOTER //
// ./src/containers/pages/Website/PageEditor/index.js